// Dashboard mock data

export const dashboardMockData = {
  metrics: {
    totalUsers: {
      current: 25749,
      previous: 22864,
      trend: 'UP',
      percentageChange: 12.5,
      comparisonPeriod: 'Previous month'
    },
    revenue: {
      current: 154920.75,
      previous: 143126.68,
      trend: 'UP',
      percentageChange: 8.3,
      comparisonPeriod: 'Previous month'
    },
    totalOrders: {
      current: 3782,
      previous: 3573,
      trend: 'UP',
      percentageChange: 5.7,
      comparisonPeriod: 'Previous month'
    },
    averageOrderValue: {
      current: 41.23,
      previous: 42.12,
      trend: 'DOWN',
      percentageChange: 2.1,
      comparisonPeriod: 'Previous month'
    },
    customerRetentionRate: {
      current: 72.5,
      previous: 69.8,
      trend: 'UP',
      percentageChange: 3.8,
      comparisonPeriod: 'Previous month'
    }
  },
  returnsOverTime: {
    data: [
      { timestamp: '2024-01-01T00:00:00Z', value: 32, label: 'Jan 1' },
      { timestamp: '2024-01-02T00:00:00Z', value: 28, label: 'Jan 2' },
      { timestamp: '2024-01-03T00:00:00Z', value: 43, label: 'Jan 3' },
      { timestamp: '2024-01-04T00:00:00Z', value: 39, label: 'Jan 4' },
      { timestamp: '2024-01-05T00:00:00Z', value: 35, label: 'Jan 5' },
      { timestamp: '2024-01-06T00:00:00Z', value: 25, label: 'Jan 6' },
      { timestamp: '2024-01-07T00:00:00Z', value: 21, label: 'Jan 7' },
      { timestamp: '2024-01-08T00:00:00Z', value: 33, label: 'Jan 8' },
      { timestamp: '2024-01-09T00:00:00Z', value: 42, label: 'Jan 9' },
      { timestamp: '2024-01-10T00:00:00Z', value: 38, label: 'Jan 10' },
      { timestamp: '2024-01-11T00:00:00Z', value: 45, label: 'Jan 11' },
      { timestamp: '2024-01-12T00:00:00Z', value: 56, label: 'Jan 12' },
      { timestamp: '2024-01-13T00:00:00Z', value: 52, label: 'Jan 13' },
      { timestamp: '2024-01-14T00:00:00Z', value: 48, label: 'Jan 14' },
      { timestamp: '2024-01-15T00:00:00Z', value: 44, label: 'Jan 15' },
      { timestamp: '2024-01-16T00:00:00Z', value: 39, label: 'Jan 16' },
      { timestamp: '2024-01-17T00:00:00Z', value: 37, label: 'Jan 17' },
      { timestamp: '2024-01-18T00:00:00Z', value: 41, label: 'Jan 18' },
      { timestamp: '2024-01-19T00:00:00Z', value: 36, label: 'Jan 19' },
      { timestamp: '2024-01-20T00:00:00Z', value: 31, label: 'Jan 20' },
      { timestamp: '2024-01-21T00:00:00Z', value: 28, label: 'Jan 21' },
      { timestamp: '2024-01-22T00:00:00Z', value: 32, label: 'Jan 22' },
      { timestamp: '2024-01-23T00:00:00Z', value: 35, label: 'Jan 23' },
      { timestamp: '2024-01-24T00:00:00Z', value: 38, label: 'Jan 24' },
      { timestamp: '2024-01-25T00:00:00Z', value: 45, label: 'Jan 25' },
      { timestamp: '2024-01-26T00:00:00Z', value: 49, label: 'Jan 26' },
      { timestamp: '2024-01-27T00:00:00Z', value: 43, label: 'Jan 27' },
      { timestamp: '2024-01-28T00:00:00Z', value: 40, label: 'Jan 28' },
      { timestamp: '2024-01-29T00:00:00Z', value: 38, label: 'Jan 29' },
      { timestamp: '2024-01-30T00:00:00Z', value: 41, label: 'Jan 30' }
    ],
    total: 1183,
    averagePerDay: 39.43,
    maxValue: 56,
    minValue: 21,
    lastUpdated: '2024-01-31T09:30:00Z'
  },
  lifecycleDistribution: {
    stages: [
      { name: 'Acquisition', count: 2450, percentage: 35, trend: 'UP', percentageChange: 5.3 },
      { name: 'Activation', count: 1845, percentage: 25, trend: 'UP', percentageChange: 2.1 },
      { name: 'Retention', count: 1200, percentage: 18, trend: 'DOWN', percentageChange: 1.7 },
      { name: 'Revenue', count: 950, percentage: 14, trend: 'UP', percentageChange: 3.5 },
      { name: 'Referral', count: 550, percentage: 8, trend: 'NEUTRAL', percentageChange: 0.2 }
    ],
    total: 6995,
    mostActive: 'Acquisition',
    lastUpdated: '2024-01-31T09:30:00Z'
  },
  recentActivities: [
    {
      id: 'act-1',
      type: 'order',
      title: 'New Order Placed',
      description: 'Order #ORD-100001 placed for $349.99',
      timestamp: '2024-01-30T14:25:00Z',
      metadata: '{"browser":"Chrome","device":"Desktop"}',
      user: {
        id: '1',
        name: 'John Doe',
        email: 'john.doe@example.com'
      },
      itemId: 'item-123',
      itemName: 'BILLY Bookcase',
      location: 'Online Store',
      status: 'completed',
      link: '/dashboard/orders/1'
    },
    {
      id: 'act-2',
      type: 'return',
      title: 'Return Request',
      description: 'Return initiated for Order #ORD-99875',
      timestamp: '2024-01-30T13:50:00Z',
      metadata: '{"browser":"Safari","device":"Mobile"}',
      user: {
        id: '2',
        name: 'Jane Smith',
        email: 'jane.smith@example.com'
      },
      itemId: 'item-456',
      itemName: 'POÄNG Chair',
      location: 'Store B',
      status: 'pending',
      link: '/dashboard/returns/2'
    },
    {
      id: 'act-3',
      type: 'login',
      title: 'User Login',
      description: 'Bob Johnson logged in from new device',
      timestamp: '2024-01-30T13:15:00Z',
      metadata: '{"browser":"Firefox","device":"Tablet"}',
      user: {
        id: '3',
        name: 'Bob Johnson',
        email: 'bob.johnson@example.com'
      },
      itemId: null,
      itemName: null,
      location: null,
      status: 'completed',
      link: '/dashboard/users/3'
    },
    {
      id: 'act-4',
      type: 'support',
      title: 'Support Ticket',
      description: 'New support ticket opened: "Delivery Issue"',
      timestamp: '2024-01-30T12:45:00Z',
      metadata: '{"browser":"Chrome","device":"Desktop"}',
      user: {
        id: '4',
        name: 'Alice Cooper',
        email: 'alice.cooper@example.com'
      },
      itemId: null,
      itemName: null,
      location: null,
      status: 'pending',
      link: '/dashboard/support/4'
    },
    {
      id: 'act-5',
      type: 'checkout',
      title: 'Checkout Initiated',
      description: 'User started checkout with 3 items',
      timestamp: '2024-01-30T12:15:00Z',
      metadata: '{"browser":"Edge","device":"Desktop"}',
      user: {
        id: '5',
        name: 'Charlie Brown',
        email: 'charlie.brown@example.com'
      },
      itemId: null,
      itemName: null,
      location: 'Online Store',
      status: 'processing',
      link: '/dashboard/checkout/5'
    },
    {
      id: 'act-6',
      type: 'order',
      title: 'New Order Placed',
      description: 'Order #ORD-100000 placed for $129.99',
      timestamp: '2024-01-30T11:45:00Z',
      metadata: '{"browser":"Chrome","device":"Mobile"}',
      user: {
        id: '6',
        name: 'Dave Wilson',
        email: 'dave.wilson@example.com'
      },
      itemId: 'item-789',
      itemName: 'KALLAX Shelf',
      location: 'Online Store',
      status: 'completed',
      link: '/dashboard/orders/6'
    },
    {
      id: 'act-7',
      type: 'return',
      title: 'Return Request',
      description: 'Return initiated for Order #ORD-99762',
      timestamp: '2024-01-30T11:15:00Z',
      metadata: '{"browser":"Safari","device":"Desktop"}',
      user: {
        id: '7',
        name: 'Eva Martinez',
        email: 'eva.martinez@example.com'
      },
      itemId: 'item-012',
      itemName: 'MALM Bed frame',
      location: 'Store A',
      status: 'processing',
      link: '/dashboard/returns/7'
    },
    {
      id: 'act-8',
      type: 'product_view',
      title: 'Product Viewed',
      description: 'User viewed product: HEMNES Dresser',
      timestamp: '2024-01-30T10:45:00Z',
      metadata: '{"browser":"Chrome","device":"Mobile"}',
      user: {
        id: '8',
        name: 'Frank Johnson',
        email: 'frank.johnson@example.com'
      },
      itemId: 'item-345',
      itemName: 'HEMNES Dresser',
      location: 'Online Store',
      status: 'completed',
      link: '/dashboard/products/8'
    },
    {
      id: 'act-9',
      type: 'login',
      title: 'User Login',
      description: 'Grace Lee logged in from new device',
      timestamp: '2024-01-30T10:15:00Z',
      metadata: '{"browser":"Firefox","device":"Desktop"}',
      user: {
        id: '9',
        name: 'Grace Lee',
        email: 'grace.lee@example.com'
      },
      itemId: null,
      itemName: null,
      location: null,
      status: 'completed',
      link: '/dashboard/users/9'
    },
    {
      id: 'act-10',
      type: 'support',
      title: 'Support Ticket',
      description: 'New support ticket opened: "Product Question"',
      timestamp: '2024-01-30T09:45:00Z',
      metadata: '{"browser":"Chrome","device":"Tablet"}',
      user: {
        id: '10',
        name: 'Henry Chang',
        email: 'henry.chang@example.com'
      },
      itemId: null,
      itemName: null,
      location: null,
      status: 'pending',
      link: '/dashboard/support/10'
    }
  ]
};